import { useUser } from '../Context/UserContext';
import OfficerDashboard from './Dashboard/OfficerDashboard';
import FarmerDashboard from './Dashboard/FarmerDashboard';
import ProductionCenterDashboard from './Dashboard/ProductionCenterDashboard';
import StatusUpdateDashboard from './Dashboard/StatusUpdateDashboard';
import WelcomeDashboard from './Dashboard/WelcomeDashboard';

const Home = () => {
  const { authData } = useUser();
  const role = authData?.role;

  // --- Define Officer Roles ---
  const OFFICER_ROLES = [
    'superadmin', 
    'department_admin', 
    'district_admin', 
    'block_admin'
  ];

  // 1. Officer / Admin Roles
  // If the role is in the list, show OfficerDashboard
  if (OFFICER_ROLES.includes(role)) {
    return <OfficerDashboard />;
  }

  // 2. Farmer Role
  if (role === 'farmer') {
    return <FarmerDashboard />;
  }

  // 3. Production Center Role Logic
  if (role === 'productioncenter') {
    const centerId = authData?.production_center_id;
    const centerStatus = authData?.production_center_status;

    // Case A: No ID -> User hasn't registered a center yet
    if (!centerId) {
      return <WelcomeDashboard />;
    }

    // Case B: ID exists, but Status is Pending or Rejected -> Show Status Screen
    if (centerStatus === 'pending' || centerStatus === 'rejected') {
      return <StatusUpdateDashboard />;
    }

    // Case C: ID exists and Status is Approved -> Show Full Dashboard
    if (centerStatus === 'approved') {
      return <ProductionCenterDashboard />;
    }
  }

  // Fallback
  return <FarmerDashboard />; 
};

export default Home;